import { PriceEntity } from '../priceEntity';

export enum ControlOverLegalClientStatusType {
  /** физическое лицо, которому прямо или косвенно принадлежит более 10% долей участия в уставном капитале или акций юридического лица */
  CapitalShareOwnership = 'CapitalShareOwnership',
  /** физическое лицо, осуществляющее контроль над юридическим лицом на иных основаниях */
  OtherControlBasis = 'OtherControlBasis',
}

export interface ControlOverEntity {
  hasControlOverLegalClient?: boolean;
  directCapitalParticipationPercentage: number;
  indirectCapitalParticipationPercentage?: number;
  financialConditionAmount?: PriceEntity;
  controlOverLegalClientStatus?: ControlOverLegalClientStatusType;
}
